import { INITIAL_VALUES } from 'app/modules/Invoices/config/filters';
import { getTabs } from 'app/modules/Invoices/config/tabs';
import {
  getColumnsToDataTable,
  getDataTableStructure,
  pgOptions,
  getNoResultsConfig
} from 'app/modules/Invoices/config/table';
import { useFiltersConfiguration } from 'app/modules/Invoices/hooks/useFiltersConfiguration';

export const getInvoicesDataTableConfiguration = ({ intl }) => ({
  INITIAL_VALUES,
  apiUrl: 'invoices',
  tabs: getTabs(intl),
  useFiltersConfiguration,
  getColumnsToDataTable,
  getNoResultsConfig,
  getDataTableStructure,
  pgOptions
});
